import React, { useEffect, useRef, memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, useTheme } from '@mui/material';

const TradingViewWidget = () => {
  const theme = useTheme();
  const { light } = useSelector((state) => state.theme);
  const { selectedCoin } = useSelector((state) => state.spotTrading);
  const container = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!selectedCoin) {
      setError('Please select a coin to view the chart.');
      return;
    }

    if (container.current) {
      while (container.current.firstChild) {
        container.current.firstChild.remove();
      }
    }

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;

    const widgetConfig = {
      autosize: true,
      symbol: `BINANCE:${selectedCoin}`,
      interval: '240',
      timezone: 'Etc/UTC',
      theme: light ? 'light' : 'dark',
      style: '1',
      locale: 'en',
      enable_publishing: false,
      hide_legend: true,
      hide_side_toolbar: false,
      save_image: false,
      calendar: false,
      support_host: 'https://www.tradingview.com',
    };

    try {
      script.innerHTML = JSON.stringify(widgetConfig);
      if (container.current) {
        container.current.appendChild(script);
        script.onload = () => {
          console.log(`Chart for ${selectedCoin} loaded successfully`);
          setError(null);
        };
        script.onerror = () => {
          setError('Failed to load TradingView chart. Please check your internet connection and try again.');
          console.error('Error loading TradingView script');
        };
      } else {
        setError('Failed to load chart: Container not available.');
        console.error('TradingView container not found');
      }
    } catch (err) {
      setError(`Error loading chart: ${err.message}`);
      console.error('Error configuring TradingView widget:', err);
    }

    return () => {
      if (container.current) {
        while (container.current.firstChild) {
          container.current.firstChild.remove();
        }
      }
    };
  }, [selectedCoin, light]);

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography sx={{ color: theme.palette.error.main }}>{error}</Typography>
      </Box>
    );
  }

  if (!selectedCoin) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography sx={{ color: theme.palette.text.secondary }}>
          Please select a coin to view the chart.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{height: '100%' }}>
      <Box
        className="tradingview-widget-container"
        ref={container}
        sx={{
          height: '100%',
          width: '95%',
          bgcolor: theme.palette.background.paper,
          borderRadius: 2,
          boxShadow: theme.shadows[2],
          p: 1,
        }}
      >
        <div
          className="tradingview-widget-container__widget"
          style={{ height: '100%', width: '100%' }}
        />
      </Box>
    </Box>
  );
};

export default memo(TradingViewWidget);